import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const BankAccountsService = {
  async getBankAccountsByBin(bin) {
    const params = generateQueryParams({
      bin_iin: bin,
      page: 1,
      size: 50,
    });

    const res = await axios.get('org/v1/clientaccounting/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async getBankAccounts(page, perPage, filters) {
    const params = generateQueryParams({ page, size: perPage, ...filters });

    const res = await axios.get('org/v1/clientaccounting/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createBankAccount(data) {
    const res = await axios.post('org/v1/clientaccounting/', data);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },
  async updateBankAccount(data, id) {
    const res = await axios.put(`org/v1/clientaccounting/${id}/`, data);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async deleteBankAccount(id) {
    const res = await axios.delete(`org/v1/clientaccounting/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
